import { z } from "zod"

export type StripeConnectOnboardingStatusDto =
  | "NOT_STARTED"
  | "PENDING"
  | "ACTIVE"
  | "RESTRICTED"

export interface StripeConnectStatusDto {
  /** Admin toggle — when false the store should not see the onboarding UI. */
  payoutsFeatureEnabled: boolean
  onboardingStatus: StripeConnectOnboardingStatusDto
  /** The connected account id, or null if none has been created yet. */
  stripeConnectAccountId: string | null
}

export interface StripeConnectOnboardingLinkDto {
  url: string
}

/**
 * A Stripe connected account belonging to one of the store's connected stores
 * that is fully onboarded and can therefore be reused. Offered in the CRM so a
 * store sharing an organisationsnummer with a sibling can point at the same
 * account instead of onboarding a second one.
 */
export interface StripeConnectLinkableAccountDto {
  storeId: string
  storeName: string
  stripeConnectAccountId: string
  onboardingStatus: StripeConnectOnboardingStatusDto
}

export const LinkExistingStripeAccountSchema = z.object({
  stripeConnectAccountId: z.string().min(1).max(255),
})
export type LinkExistingStripeAccount = z.infer<
  typeof LinkExistingStripeAccountSchema
>
